import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'
import HomeViewold from '../views/HomeViewold.vue'
import HomeView from '../views/HomeView.vue'
import AbilityCenter from '../views/AbilityCenter.vue'
import NationalMap from '../views/NationalMap.vue'
import IndustryChainMap from '../views/IndustryChainMap.vue'
import IndustryChainMapV2 from '../views/IndustryChainMapV2.vue'
import OriginCenter from '../views/OriginCenter.vue'
import IndustryWarehouse from '../views/IndustryWarehouse.vue'
import ComponentOverview from '../views/ComponentOverview.vue'
import login from '../views/login/login.vue'
import newImage from '../views/newImage.vue'
Vue.use(VueRouter)

const routes = [{
	path: '/login',
	name: 'login',
	component: login,
}, {
	path: '/',
	name: 'index',
	component: index,
		children: [{
			path: '/',
			name: 'HomeView',
			component: HomeView,
		}, {
			path: 'ability',
			name: 'AbilityCenter',
			component: AbilityCenter,
		}, {
			path: 'nationalMap',
			name: 'NationalMap',
			component: NationalMap,
		}, {
			path: 'industryChain',
			name: 'IndustryChainMap',
			component: IndustryChainMap,
		}, {
			path: 'industryChainV2',
			name: 'IndustryChainMapV2',
			component: IndustryChainMapV2,
		}, {
			path: 'origin',
			name: 'OriginCenter',
			component: OriginCenter,
		}, {
			path: 'warehouse',
			name: 'IndustryWarehouse',
			component: IndustryWarehouse,
		}, {
			path: 'componentOverview',
			name: 'ComponentOverview',
			component: ComponentOverview,
		}]
}, {
	path: '/newImage',
	name: 'newImage',
	component: newImage,
}, {
	path: '/viewsO',
	name: 'HomeViewold',
	component: HomeViewold,
}]

const router = new VueRouter({
	// mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
